'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getWindow = require('ui-addon-upgrades/_core/common/navigation/getWindow');

var _isCompatible = function _isCompatible() {
  return Boolean((0, _getWindow.getWindow)().localStorage);
};

var LocalSettings = {
  get: function get(key) {
    if (!_isCompatible()) {
      return null;
    }

    return (0, _getWindow.getWindow)().localStorage.getItem(key);
  },
  set: function set(key, value) {
    if (!_isCompatible()) {
      return null;
    }

    (0, _getWindow.getWindow)().localStorage.setItem(key, value);
    return true;
  }
};

exports.default = LocalSettings;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/localData/LocalSettings.js
// module id = 474
// module chunks = 3 4 5